import { surpriseApi } from './api'

export interface AssignmentsReturn {
  applicationId: string
}

const createAssignment = async (
  userTeam: string,
): Promise<AssignmentsReturn> => {
  const response = await surpriseApi.post(
    '/surprise-applications/assignments/next',
    userTeam.split(','),
  )

  if (response.status === 204) {
    throw Error('no_response_content')
  }

  const applicationId = response.data.applicationId
  return { applicationId }
}

export { createAssignment }
